import React from "react";
import AdminStatCard from "./AdminStatCard";
import { MEDIDROP_COLORS } from "@/config/colors";

const AdminMediDropStatCard = (props) => (
  <AdminStatCard
    gradientFrom={MEDIDROP_COLORS.ORANGE}
    gradientTo={MEDIDROP_COLORS.ORANGE_DARK}
    borderColor={MEDIDROP_COLORS.ORANGE_LIGHT}
    titleColor="white"
    valueColor="white"
    iconGhostColor="white"
    {...props}
  />
);

export default AdminMediDropStatCard;
